// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3sglW","amount":"Amount_amount__2oFsj","tip":"Amount_tip__3Dm9r","tipHeader":"Amount_tipHeader__GhyLj","tipsWrap":"Amount_tipsWrap__3j_Tz"};